import Page from "framework/ui/content/Page";
import PageContent from "framework/ui/content/PageContent";
import PageSections from "framework/ui/content/PageSections";
import Copyright from "framework/ui/content/Copyright";
import Logo from "framework/ui/content/Logo";
import logo from "./assets/logo.png";
import './css/Gallery.css'
import './css/GuestBook.css'
import './css/NavBar.css'
import './css/PageSections.css'
import PageTitle from "framework/ui/content/PageTitle";

/**
 * @typedef MyPageProps
 *
 * @property {number} [pageId]  Specific page ID to display.
 */

/**
 * Component for site-specific page contents.
 *
 * @param props {MyPageProps}
 * @returns {JSX.Element}
 * @constructor
 */
export default function MyPage(props) {
  return (
    <Page {...props}>
      <Logo src={logo}/>
      <PageContent>
        <PageTitle />
        <PageSections/>
      </PageContent>
      <Copyright startYear={'2022'}/>
    </Page>
  )
}